import { BookOpen, Users, Award, GraduationCap } from "lucide-react"
import { useState, useEffect } from "react"
import SEO from "../SEO"

export default function PranaamKnowledge() {
  const knowledgeSchema = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://pranaamhospitals.com/#organization",
    "name": "Pranaam Hospitals",
    "url": "https://pranaamhospitals.com/",
    "logo": "https://pranaamhospitals.com/images/pranaam-logo.png",
    "description": "Explore Pranaam Knowledge at Pranaam Hospitals, offering medical education, training programs, workshops, CME sessions, and certifications in obstetrics, gynecology, and pediatrics.",
    "sameAs": [
      "https://www.facebook.com/pranaamhospitals",
      "https://www.instagram.com/pranaamhospitals",
    ]
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id": "https://pranaamhospitals.com/knowledge#breadcrumb",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://pranaamhospitals.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Knowledge",
        "item": "https://pranaamhospitals.com/knowledge"
      }
    ]
  }
];
const [seo, setSeo] = useState({});
      const [pageKeywords, setPageKeywords] = useState("");
    const [pageData, setPageData] = useState(null);
    useEffect(() => {
      fetch("/wp-json/custom/v1/page-seo?slug=knowledge")
      .then(res => res.json())
      .then(data => { if (data?.seo) setSeo(data.seo); setPageKeywords(data?.keywords || ""); })
      .catch(() => {});
    }, []);

  return (
    <>
      <SEO
        title={seo.title || "Knowledge | Pranaam Hospitals"}
        description={seo.description || "Explore the Pranaam Hospitals Knowledge Center for expert health articles, wellness tips, disease awareness, preventive care guidance, and trusted medical information from healthcare specialists."}
        canonical={seo.canonical || "https://pranaamhospitals.com/knowledge"}
        robots={Array.isArray(seo.robots) ? seo.robots.join(", ") : seo.robots || "index, follow"}
        keywords={pageKeywords}
        ogTitle={seo.og_title}
        ogDescription={seo.og_description}
        ogImage={seo.og_image || seo.featured_image}
        twitterTitle={seo.twitter_title}
        twitterDescription={seo.twitter_description}
        author="Pranaam Hospitals"
        publisher="Pranaam Hospitals"
        schema={knowledgeSchema}
      />
    <main className="min-h-screen bg-gray-50">
      <div className="bg-primary text-white py-12 md:py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">Pranaam Knowledge</h1>
          <p className="text-lg md:text-xl text-white/90">Empowering Healthcare Professionals Through Education</p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="bg-white rounded-xl shadow-sm p-6 md:p-8 mb-8">
          <img src="/wp-content/uploads/2026/05/WomensHealthcareTeam.webp" alt="Healthcare Team" className="w-full h-auto max-h-80 object-contain rounded-lg mb-6" />
          <h2 className="text-2xl md:text-3xl font-bold mb-4">Medical Education & Training</h2>
          <p className="text-gray-600 mb-6">
            Pranaam Hospitals is committed to advancing medical education and training in women's and children's healthcare. 
            Our comprehensive programs focus on developing skilled healthcare professionals who deliver exceptional patient care.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
              <GraduationCap className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-xl font-bold mb-3">Training Programs</h3>
            <p className="text-gray-600">Specialized training in obstetrics, gynecology, and pediatrics</p>
          </div>

          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
              <Users className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-xl font-bold mb-3">Workshops & CME</h3>
            <p className="text-gray-600">Regular continuing medical education programs and workshops</p>
          </div>

          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
              <Award className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-xl font-bold mb-3">Certifications</h3>
            <p className="text-gray-600">Accredited certification programs for healthcare professionals</p>
          </div>
        </div>
      </div>
    </main>
    </>
  )
}
